import * as yup from 'yup'
import yupPassword from 'yup-password'

yupPassword(yup)

export interface ITextRequired {
  messageRequired?: string
}

export interface IEmailSchema extends ITextRequired {
  messageEmail?: string
}

export const emailSchema = (
  payload: IEmailSchema = {
    messageEmail: 'signin.emailMessageValidError',
    messageRequired: 'signin.emailRequiredError',
  }
) => yup.string().email(payload.messageEmail).required(payload.messageRequired)

export const passwordSchema = (payload: ITextRequired = { messageRequired: 'signin.passwordRequiredError' }) =>
  yup.string().required(payload.messageRequired)

export const newPasswordSchema = (payload: ITextRequired = { messageRequired: 'signin.passwordRequiredError' }) =>
  yup
    .string()
    .required(payload.messageRequired)
    .min(8, 'restore_password.min_symbols_error')
    .minLowercase(1, 'Password must contain at least 1 lower case letter')
    .minUppercase(1, 'Password must contain at least 1 upper case letter')
    .minNumbers(1, 'Password must contain at least 1 number')
    .minSymbols(1, 'Password must contain at least 1 special character')
